import axios, { AxiosError } from "axios";

export const http = axios.create({
  baseURL: "/api",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

http.interceptors.request.use((config) => {
  const token = localStorage.getItem("auth_token");
  if (token !== null) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
});

http.interceptors.response.use(
  (response) => response,
  (error: AxiosError) => {
    // Surface the backend's user-facing error message (e.g. "A creator with
    // username X already exists on instagram for this organization") instead
    // of axios's generic "Request failed with status code 409".
    const body = error.response?.data as
      | { error?: { message?: string; code?: string } }
      | undefined;
    const message = body?.error?.message;
    if (typeof message === "string" && message !== "") {
      error.message = message;
    }

    // A 401 from any non-auth endpoint means the session is no longer
    // accepted by the server (expired, secret rotated, or the account was
    // wiped by a factory reset). Clear the stale session and return to login.
    // Login/register requests may legitimately 401 on bad credentials and are
    // handled by the auth page itself.
    if (error.response?.status === 401) {
      const url = error.config?.url ?? "";
      const isAuthAttempt =
        url.includes("/auth/login") ||
        url.includes("/auth/register") ||
        url.includes("/identity/login") ||
        url.includes("/identity/register");
      if (!isAuthAttempt) {
        const code = body?.error?.code;
        if (code === "AGENCY_SUSPENDED" || code === "AGENCY_DEACTIVATED" || code === "SESSION_PASSWORD_CHANGED") {
          try {
            sessionStorage.setItem("auth_notice", message ?? "Your agency is not active.");
          } catch {
            // storage unavailable: the login page still shows the server error on sign-in
          }
        }
        localStorage.removeItem("auth_token");
        localStorage.removeItem("auth_user");
        localStorage.removeItem("auth_org");
        if (typeof window !== "undefined" && window.location.pathname !== "/login") {
          window.location.assign("/login");
        }
      }
    }

    return Promise.reject(error);
  },
);
